<template>
  <div class="referral-page-wrapper">
    <Breadcrumbs main="" title="Referral program" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="referral-content">
            <!-- Statistics Section -->
            <div class="referral-stats-container">
              <div class="referral-top-section">
                <p class="referral-subtitle">Copy this link to referrer the user and earn a commission</p>
                <AddMonitorButton :iconOnly="true" variant="green" />
              </div>
              
              <div class="referral-header">
                <h2 class="referral-link-title">Referral Link</h2>
              </div>
              
              <!-- Referral Link Section -->
              <div class="referral-link-section">
                <div class="referral-link-wrapper">
                  <div class="referral-link-input-group">
                    <img src="@/assets/icons/per-page.svg" alt="Link" class="link-icon" />
                    <input 
                      type="text" 
                      class="referral-link-input" 
                      v-model="refurl" 
                      readonly
                      @click="selectAll"
                    />
                  </div>
                  <button 
                    class="referral-copy-btn"
                    :class="{ 'copied': isCopied }"
                    @click="copyUrl"
                  >
                    <img src="@/assets/icons/Copy.svg" alt="Copy" class="copy-icon" />
                    {{ isCopied ? 'Copied' : 'Copy' }}
                  </button>
                </div>
              </div>
              <!-- Stats Cards -->
              <div class="referral-stats-cards">
                <div class="stats-card">
                  <div class="stats-icon-value">
                    <img src="@/assets/icons/User.svg" alt="Users" class="stats-icon" />
                    <h2 class="stats-value">{{ referCounts.registerUserCount.toString().padStart(2, '0') }}</h2>
                  </div>
                  <p class="stats-label">Registered Users</p>
                </div>

                <div class="stats-card">
                  <div class="stats-icon-value">
                    <img src="@/assets/icons/paying-user.svg" alt="Paying Users" class="stats-icon" />
                    <h2 class="stats-value">{{ referCounts.payingUserCount }}%</h2>
                  </div>
                  <p class="stats-label">Paying Users</p>
                </div>

                <div class="stats-card">
                  <div class="stats-icon-value">
                    <img src="@/assets/icons/earning-to-paid.svg" alt="Earnings" class="stats-icon" />
                    <h2 class="stats-value">${{ referCounts.paybleAmount }}</h2>
                  </div>
                  <p class="stats-label">Earning to be Paid</p>
                </div>
              </div>
            </div>

            <!-- FAQ Section -->
            <div class="referral-faq-container">
              <h2 class="faq-title">Frequently asked questions</h2>
              <p class="faq-subtitle">Have questions? Here you'll find the answers most valued by our partners, along with access to step-by-step instructions and support.</p>
              
              <div class="faq-accordion">
                <div 
                  v-for="(faq, index) in faqs" 
                  :key="index"
                  class="faq-item"
                  :class="{ 'active': activeIndex === index }"
                >
                  <div class="faq-header" @click="toggleAccordion(index)">
                    <h3 class="faq-question">{{ faq.question }}</h3>
                    <button class="faq-toggle">
                      <img v-if="activeIndex === index" src="@/assets/icons/minus-circle.svg" alt="Collapse" />
                      <img v-else src="@/assets/icons/plus-circle.svg" alt="Expand" />
                    </button>
                  </div>
                  <transition name="faq-content">
                    <div v-if="activeIndex === index" class="faq-content">
                      <div class="faq-answer" v-html="faq.answer"></div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../../services/config";
import UserController from "../../services/userController";
import AddMonitorButton from "../components/addMonitorButton.vue";

export default {
  name: "Referral",
  components: {
    AddMonitorButton
  },
  data() {
    return {
      refurl: "",
      userinfo: {},
      referCounts: { registerUserCount: 0, payingUserCount: 0, paybleAmount: 0 },
      isCopied: false,
      activeIndex: 0,
      faqs: [
        {
          question: "What is the referral program?",
          answer: "The referral program is a way to earn money by referring users to Makeping. You will get a commission for every user you refer to Makeping."
        },
        {
          question: "How does it work?",
          answer: "You will get a referral link. You can share this link with your friends, family, colleagues, etc. When they sign up for Makeping using your referral link, you will get a commission."
        },
        {
          question: "What is the commission rate?",
          answer: "<strong>You will get a 20% LIFETIME (recurring) commission</strong> from each full price payment made by a referred user who registers and then subscribes through the link with your unique affiliate ID. In case of a discounted price, the commission is reduced by the percentage amount of the discount."
        },
        {
          question: "How about cookies expiration?",
          answer: "<strong>Cookies are valid for 30 days,</strong> so the referred user needs to register the Makeping account within 30 days after clicking on the link with your affiliate ID. If the user subscribes to one of the paid plans later, you will get the commission either way. Keep in mind that if the user registers by using a link with someone else's affiliate ID or without it and subscribes later by using your affiliate ID link, you will not earn the commission."
        },
        {
          question: "When do I get paid?",
          answer: "The commissions are paid once a month via PayPal. You can request the payout upon reaching a minimum threshold of $100. Keep in mind that we reserve the right to postpone the payout until at least two different users are referred to avoid self-referrals."
        },
        {
          question: "Are there any restricted affiliate activities?",
          answer: `As we want to keep our Affiliate Program fair, there are some restricted activities:
          <ul>
            <li>Coupon sites</li>
            <li>PPC advertising with a direct link leading to any Makeping website (including all the tools and landing pages)</li>
            <li>Using any Makeping brand, logo or name of the tools or their misspelled versions in PPC advertising, in domains, subdomains, or in profiles on social media</li>
            <li>Using misleading or incorrect information (non-existent discounts, etc.)</li>
            <li>Using discount coupons that are not assigned to you</li>
            <li>The so-called 'self-referrals' (when you create another account while referring yourself)</li>
          </ul>`
        }
      ]
    };
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"));
    this.refurl = Config.refUrl + '?refererid=' + this.userinfo.userid;
    this.GetRefCounts();
  },
  methods: {
    async GetRefCounts() {
      let response = await UserController.getRefCount();
      if (response.result) {
        this.referCounts = response.data;
      } else {
        this.$toasted.show(response.message, {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
      }
    },
    async copyUrl() {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.refurl);
        } else {
          const el = document.createElement('textarea');
          el.addEventListener('focusin', e => e.stopPropagation());
          el.value = this.refurl;
          el.style.position = 'fixed';
          el.style.opacity = '0';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
        }
        
        this.isCopied = true;
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
        
        this.$toasted.show('URL copied to clipboard.', {
          theme: 'outline',
          position: "bottom-center", 
          type: 'success', 
          duration: 2000
        });
      } catch (err) {
        this.$toasted.show('Failed to copy URL', {
          theme: 'outline',
          position: "bottom-center", 
          type: 'error', 
          duration: 2000
        });
      }
    },
    selectAll(event) {
      event.target.select();
    },
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    }
  }
};
</script>

<style scoped>
/* Main wrapper */
.referral-page-wrapper {
  padding: 0;
}

.referral-content {
  padding: 24px 0;
}

/* Statistics Container */
.referral-stats-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* Top Section */
.referral-top-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.referral-subtitle {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

/* Add Monitor Button styles handled by component */

.referral-header {
  text-align: center;
}

.referral-link-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
  text-align: center;
}

/* Referral Link Section */
.referral-link-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.referral-link-wrapper {
  display: flex;
  gap: 0;
  margin: 0 auto 40px auto;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  height: 56px;
  overflow: hidden;
  max-width: 800px;
}

.referral-link-input-group {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  padding: 10px 0 10px 16px;
  height: 56px;
  min-width: 600px;
}

.link-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: block;
}

.referral-link-input {
  flex: 1;
  border: none;
  background: transparent;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.429em;
  color: #344054;
  outline: none;
  cursor: pointer;
}

.referral-copy-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  padding: 10px 20px;
  background: #007BFF;
  border: none;
  border-radius: 12px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5em;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 56px;
  width: 125px;
}

.referral-copy-btn:hover {
  background: #1175D3;
}

.referral-copy-btn.copied {
  background: #10B981;
}

.copy-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

/* Stats Cards */
.referral-stats-cards {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  gap: 50px;
  position: relative;
}

.referral-stats-cards::before {
  content: '';
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  height: 1px;
  background: #E1E1E1;
}

.stats-card {
  flex: 1;
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.stats-icon-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.stats-icon {
  width: 32px;
  height: 32px;
}

.stats-value {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

.stats-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

/* FAQ Container */
.referral-faq-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  margin-top: 24px;
}

.faq-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0 0 10px 0;
  text-align: center;
}

.faq-subtitle {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0 0 25px 0;
  text-align: center;
}

/* FAQ Accordion */
.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.faq-item {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 30px;
  transition: all 0.2s ease;
}

.faq-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  cursor: pointer;
}

.faq-question {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
  flex: 1;
}

.faq-toggle {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.faq-toggle img {
  width: 24px;
  height: 24px;
}

.faq-content {
  padding-top: 15px;
}

.faq-answer {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.3em;
  color: #3A3A3A;
}

.faq-answer strong {
  font-weight: 600;
  color: #101828;
}

.faq-answer ul {
  margin: 12px 0 0 0;
  padding-left: 20px;
}

.faq-answer ul li {
  margin-bottom: 8px;
  list-style: none;
  position: relative;
  padding-left: 16px;
}

.faq-answer ul li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #475467;
}

/* Transitions */
.faq-content-enter-active,
.faq-content-leave-active {
  transition: all 0.2s ease;
  max-height: 500px;
  overflow: hidden;
}

.faq-content-enter,
.faq-content-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .referral-stats-container,
  .referral-faq-container {
    padding: 20px;
    gap: 30px;
  }

  .referral-top-section {
    margin-bottom: 20px;
  }

  .referral-subtitle {
    font-size: 14px;
  }

  .referral-link-wrapper {
    flex-direction: column;
    height: auto;
    padding: 8px;
    gap: 8px;
  }

  .referral-link-input-group {
    width: 100%;
    height: 48px;
    padding: 8px 12px;
    min-width: unset;
  }

  .referral-copy-btn {
    width: 100%;
    justify-content: center;
    height: 48px;
    font-size: 16px;
  }

  .referral-stats-cards {
    flex-direction: column;
    gap: 20px;
  }

  .referral-stats-cards::before {
    top: -30px;
  }

  .stats-card {
    padding: 20px;
    gap: 20px;
  }

  .stats-value {
    font-size: 24px;
  }

  .stats-label {
    font-size: 16px;
  }

  .faq-title {
    font-size: 20px;
  }

  .faq-subtitle {
    font-size: 14px;
  }

  .faq-accordion {
    gap: 16px;
  }

  .faq-item {
    padding: 20px;
  }

  .faq-question {
    font-size: 18px;
  }

  .faq-answer {
    font-size: 14px;
  }
}
</style>